import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselDotFn = /* @__PURE__ */ createRecipe('carousel-dot', {
  "selected": false
}, [])

const carouselDotVariantMap = {
  "selected": [
    "true",
    "false"
  ]
}

const carouselDotVariantKeys = Object.keys(carouselDotVariantMap)

export const carouselDot = /* @__PURE__ */ Object.assign(memo(carouselDotFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselDot',
  __getCompoundVariantCss__: carouselDotFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselDotVariantKeys,
  variantMap: carouselDotVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselDotVariantKeys)
  },
  getVariantProps: carouselDotFn.getVariantProps,
})